import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from '@base/environments/environment';
import { Constants } from '@base/src/app/models/constants';
import { DialogEvent } from '@base/src/app/models/dialog-event.model';
import { QRDatePicker } from '@base/src/app/models/qr-date-picker.model';
import { QRDropdown } from '@base/src/app/models/qr-dropdown.model';
import * as moment from 'moment';

@Component({
  selector: 'app-disable-team',
  templateUrl: './rrhh-disable-team.component.html',
  styleUrls: ['./rrhh-disable-team.component.scss'],
})
export class RrhhDisableTeamComponent implements OnInit {
  NODE = environment.node;
  NODE_DO = Constants.TENANT_ID_DO;

  @Output() dialogChange: EventEmitter<DialogEvent> =
    new EventEmitter<DialogEvent>();
  @Input() value!: {
    createdDate?: string;
    teamLeader: string;
    agents: {
      name: string;
      lastName: string;
      id: number;
      agentType: string;
      agentLevelType: string;
    }[];
    types: { id: string; label: string }[];
  };
  currentDate: string = moment().format('YYYY-MM-DD'); // Fecha actual
  dateSelected: string = this.currentDate;
  inputDatePickerHasError: boolean = false;
  datePickerEmpty: QRDatePicker = {
    date: this.currentDate,
    calendarWidth: 224,
    isDisplayedUp: false,
    errorMsg: 'La fecha de baja no puede ser posterior al día actual.',
    maxDate: this.currentDate,
  };

  dropdownAgensToBeDeleted: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: this.NODE === this.NODE_DO ? 'Split' : 'Tipo',
    options: [],
  };

  dropdownAgensLevelToBeDeleted: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Tipo',
    options: ['Broker Manager', 'Broker Owner', 'Senior'],
  };

  agentLevelTypes: { id: string; label: string }[] = [
    { id: 'BROKER', label: 'Broker' },
    { id: 'SENIOR', label: 'Senior' },
    { id: 'JUNIOR', label: 'Junior' },
  ];

  MAP: Record<string, string> = {
    'Broker Manager': 'BROKER_MANAGER',
    'Broker Owner': 'BROKER_OWNER',
    Senior: 'SENIOR',
    Junior: 'JUNIOR',
  } as const;

  MAP_REVERSE: Record<string, string> = {
    BROKER_MANAGER: 'Broker Manager',
    BROKER_OWNER: 'Broker Owner',
    SENIOR: 'Senior',
    JUNIOR: 'Junior',
  } as const;

  ngOnInit(): void {
    this.generateAgentTypes();
    this.checkForm();
    if (this.value.createdDate) {
      this.datePickerEmpty = {
        ...this.datePickerEmpty,
        minDate: this.value.createdDate,
      };
    }
  }

  generateAgentTypes() {
    if (this.value.types) {
      this.value.types.forEach((e) => {
        const IS_TEAM = e.id.includes('TEAM');
        const IS_SPLIT_100_DO =
          this.NODE === this.NODE_DO && e.id === 'SPLIT_100';
        if (!IS_TEAM && !IS_SPLIT_100_DO) {
          this.dropdownAgensToBeDeleted.options.push(e.label);
        }
      });
      this.dropdownAgensToBeDeleted.options.sort((a: string, b: string) => {
        const NUM_A = parseInt(a.replace('%', ''), 10);
        const NUMB_B = parseInt(b.replace('%', ''), 10);
        return NUMB_B - NUM_A;
      });
    }
  }

  datepickerChange(e: string): void {
    const dateSelected = moment(e);
    this.dateSelected = e;
    if (dateSelected.isAfter(this.currentDate)) {
      this.inputDatePickerHasError = true;
    } else {
      this.inputDatePickerHasError = false;
    }
    this.checkForm();
  }

  checkForm() {
    let dialogEvent: DialogEvent = {
      isButtonActionDisabled:
        this.inputDatePickerHasError || this.hasBlankAgentType,
      value: { date: this.dateSelected, agents: this.value.agents },
    };
    this.dialogChange.emit(dialogEvent);
  }

  changeAgentType($event: string, id: number) {
    const AGENT = this.value.agents.find((e) => e.id === id);
    if (AGENT) AGENT.agentType = $event;
    this.checkForm();
  }

  changeAgentLevelType(
    $event: 'Broker Manager' | 'Broker Owner' | 'Senior' | 'Junior',
    id: number
  ) {

    const AGENT = this.value.agents.find((e) => e.id === id);
    if (AGENT) {
      AGENT.agentLevelType = this.MAP[$event];
    }

    this.checkForm();
  }

  get hasBlankAgentType(): boolean {
    if (this.NODE === this.NODE_DO) {
      return (
        (this.value.agents ?? []).some(
          (a) => (a.agentType ?? '').trim() === ''
        ) ||
        (this.value.agents ?? []).some(
          (a) => (a.agentLevelType ?? '').trim() === ''
        )
      );
    } else {
      return (this.value.agents ?? []).some(
        (a) => (a.agentType ?? '').trim() === ''
      );
    }
  }
}
